import { useRouter } from 'next/router';
import useMenuFilterOptions from './use-menu-filter-options';

type Subcategory = { key: string; label: string; value: string };

export function useDispensarySubcategory(): { subcategory: string | null } {
  const { subcategories } = useMenuFilterOptions({ skipCurrentFilters: true });

  const {
    query: { subcategory: subcategoryFromPath, subcategories: subcategoriesQueryParam },
  } = useRouter();

  const subcategory = subcategoryFromPath ?? subcategoriesQueryParam;
  const subcategoryExists =
    Array.isArray(subcategories) &&
    (subcategories as Subcategory[]).some((subcategoryFromFilters) => subcategoryFromFilters.key === subcategory);

  if (!subcategory || typeof subcategory !== 'string' || !subcategoryExists) {
    return { subcategory: null };
  }

  return { subcategory };
}
